// extracted by mini-css-extract-plugin
export default {"container":"Rca-z","oos":"Sca-z","oosUx":"Tca-z","selected":"Uca-z","labelOos":"Vca-z"};